import React, { useEffect, useState, useRef } from 'react';
import './Testimonios.css';

// const tituloFijo = 'CASOS DE ÉXITO';

const testimonios = [
  {
    desktop: '/images/testimonios/testimonio-1-desktop.png',
    movil: '/images/testimonios/testimonio-1-movil.png',
    alt: 'Testimonio 1',
    texto: '“ Gracias a Recomienda-T mi red de negocios creció exponencialmente.',
    nombre: 'José Chávez',
    bio: {
      titulo: 'Maestro en Tecnologías de Información',
      cargo: 'CEO de Tiendamax',
      cargo2: 'Co-Founder de CIMA Business Center',
      institucion: 'Instituto Tecnológico de Morelia',
    },
  },
  {
    desktop: '/images/testimonios/testimonio-2-desktop.png',
    movil: '/images/testimonios/testimonio-2-movil.png',
    alt: 'Testimonio 2',
    texto: '" El apoyar a la comunidad ha sido clave para mi éxito.',
    nombre: 'Alexander',
  },
  {
    desktop: '/images/testimonios/testimonio-3-desktop.png',
    movil: '/images/testimonios/testimonio-3-movil.png',
    alt: 'Testimonio 3',
    texto: '"La Concept Store me ayudo a expandir mi red de distribución de Café.',
    nombre: 'Alfonso Carrera',
  },
  {
    desktop: '/images/testimonios/testimonio-4-desktop.png',
    movil: '/images/testimonios/testimonio-4-movil.png',
    alt: 'Testimonio 4',
    texto: '" Son los mejores aliados de negocios, ¡Gracias Recomienda-T!',
    nombre: 'Pablo Ferreyra',
    bio: {
      titulo: 'Lic. en Negocios Internacionales',
      cargo: 'Presidente de CIMA Business Center',
      cargo2: 'Director de planeación de GRUPO FERLO',
      institucion: 'Universidad De Morelia UDEM',
    },
  },
];

function shuffleArray(array) {
  const arr = array.slice();
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function Testimonios() {
  const [orden, setOrden] = useState(() => shuffleArray(testimonios));
  const [index, setIndex] = useState(0);
  const intervalRef = useRef();
  // const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    setOrden(shuffleArray(testimonios));
    setIndex(0);
  }, []);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setIndex(i => (i + 1) % orden.length);
    }, 5000);
    return () => clearInterval(intervalRef.current);
  }, [orden]);

  // useEffect(() => {
  //   const handleResize = () => setIsMobile(window.innerWidth <= 900);
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);

  return (
    <section className="testimonios-section">
      <div className="testimonios-slider">
        <div className="testimonios-slider-inner" style={{ transform: `translateX(-${index * 100}%)` }}>
          {orden.map((testimonio, i) => (
            <div className="testimonio" key={i}>
              <img
                src={window.innerWidth <= 900 ? testimonio.movil : testimonio.desktop}
                alt={testimonio.alt}
                className="testimonio-img"
                draggable="false"
              />
              {testimonio.bio && (
                <div className="testimonio-bio">
                  <div className="testimonio-bio-titulo">{testimonio.bio.titulo}</div>
                  <div className="testimonio-bio-cargo">{testimonio.bio.cargo}</div>
                  {testimonio.bio.cargo2 && (
                    <div className="testimonio-bio-cargo">{testimonio.bio.cargo2}</div>
                  )}
                  {testimonio.bio.institucion && (
                    <div className="testimonio-bio-institucion">{testimonio.bio.institucion}</div>
                  )}
                </div>
              )}
              <div className="testimonio-texto">
                <div className="testimonio-comentario">{testimonio.texto}</div>
                <div className="testimonio-nombre">{testimonio.nombre}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
} 